import { useCanvasStore } from '../canvas-store'

// Tiny pulsing dot pinned to the corner of a card whose background enrichment
// (URL scrape, video analysis, etc) is still in flight. Disappears once the
// orchestrator-side write back lands and the store clears its id.
export function EnrichingIndicator({ itemId }: { itemId: string }) {
  const isEnriching = useCanvasStore((s) => s.enrichingIds.has(itemId))
  if (!isEnriching) return null
  return (
    <span
      title="Reading the page in the background"
      className="absolute left-2.5 top-2.5 z-10 flex h-2 w-2"
      aria-label="Enriching">
      <span className="bg-primary/60 absolute inline-flex h-full w-full animate-ping rounded-full" />
      <span className="bg-primary relative inline-flex h-2 w-2 rounded-full" />
    </span>
  )
}
